import { MessagingTemplateDetailsState } from "@idw-types/state/messaging-template-details-state";
import { MessagingTemplateDetailsActionTypes, MessagingTemplateDetailsActions } from "../actions/messaging-template-details-actions";

export const initialMessagingTemplateDetailsState: MessagingTemplateDetailsState = {
    messagingTemplate: {
        isLoading: false,
        messagingTemplate: null
    }
};

export const messagingTemplateDetailsReducer = (
    state: MessagingTemplateDetailsState = initialMessagingTemplateDetailsState,
    action: MessagingTemplateDetailsActions
): MessagingTemplateDetailsState => {
    switch (action.type) {
        // Messaging Template Details
        case MessagingTemplateDetailsActionTypes.SET_MESSAGING_TEMPLATE_DETAILS_LOADING:
            return {
                ...state,
                messagingTemplate: {
                    ...(action.payload.isLoading
                        ? { ...initialMessagingTemplateDetailsState.messagingTemplate }
                        : { ...state.messagingTemplate }),
                    isLoading: action.payload.isLoading
                }
            };
        case MessagingTemplateDetailsActionTypes.SET_MESSAGING_TEMPLATE_DETAILS:
            return {
                ...state,
                messagingTemplate: {
                    messagingTemplate: action.payload.messagingTemplate,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};